/**
 * Utilitários para codificar/decodificar dados de agendamento em URLs.
 * Usado para criar links de pré-preenchimento no WhatsApp.
 */

/**
 * Codifica dados do agendamento para uso em query params.
 * Usa Base64 URL-safe para evitar problemas com caracteres especiais.
 * 
 * @param {Object} data - Dados do agendamento
 * @param {number} data.serviceId - ID do serviço
 * @param {string} data.serviceName - Nome do serviço
 * @param {number} data.userId - ID do funcionário
 * @param {string} data.userFullname - Nome do funcionário
 * @param {string} data.date - Data/hora no formato ISO
 * @param {string} data.customer - Nome do cliente
 * @returns {string} String codificada em Base64 URL-safe
 */
export const encodeAppointmentData = (data) => {
    try {
        const jsonString = JSON.stringify(data);
        // Converte para Base64 e substitui caracteres problemáticos para URL
        const base64 = btoa(encodeURIComponent(jsonString));
        return base64.replace(/\+/g, '-').replace(/\//g, '_').replace(/=/g, '');
    } catch (error) {
        console.error('Erro ao codificar dados do agendamento:', error);
        return null;
    }
};

/**
 * Decodifica dados do agendamento de query params.
 * 
 * @param {string} encoded - String codificada em Base64 URL-safe
 * @returns {Object|null} Dados do agendamento ou null se inválido
 */
export const decodeAppointmentData = (encoded) => {
    try {
        if (!encoded) return null;

        // Restaura caracteres Base64 originais
        let base64 = encoded.replace(/-/g, '+').replace(/_/g, '/');

        // Adiciona padding se necessário
        while (base64.length % 4) {
            base64 += '=';
        }

        const jsonString = decodeURIComponent(atob(base64));
        return JSON.parse(jsonString);
    } catch (error) {
        console.error('Erro ao decodificar dados do agendamento:', error);
        return null;
    }
};

/**
 * Gera a URL completa para o admin com dados de pré-preenchimento.
 * 
 * @param {Object} data - Dados do agendamento (ver encodeAppointmentData)
 * @returns {string} URL completa para o calendário do admin
 */
export const generatePrefillUrl = (data) => {
    const encoded = encodeAppointmentData(data);
    if (!encoded) return null;

    // Usa window.location.origin para obter a URL base dinamicamente
    const baseUrl = typeof window !== 'undefined'
        ? window.location.origin
        : '';

    return `${baseUrl}/admin/calendario?prefill=${encoded}`;
};
